// export const BASE_URL = "http://localhost:8000";
// export const BASE_URL = "https://quiz-learn-backend.vercel.app";
export const BASE_URL = process.env.REACT_APP_BACKEND_URL;
